import { render, staticRenderFns } from "./CorpInfoCard.vue?vue&type=template&id=1fb0affe"
import script from "./CorpInfoCard.vue?vue&type=script&lang=js"
export * from "./CorpInfoCard.vue?vue&type=script&lang=js"
import style0 from "./CorpInfoCard.vue?vue&type=style&index=0&id=1fb0affe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports